module.exports = __webpack_public_path__ + "static/img/enterprise_img_3_en.48c9b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/enterprise_img_3_en.png
// module id = 1Mtn
// module chunks = 0